const MeasurmentTypes = {
  ORDER_GRADING_GROUPS: 'ORDER_GRADING_GROUPS',
  GET_SAMPLE_SIZE_NAME: 'GET_SAMPLE_SIZE_NAME',
};
export default MeasurmentTypes;
